import { Component, OnInit } from '@angular/core';
import { PurchaseOrderPickUpLine } from 'app/core/model/purchase-order-pick-up-line';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-pickup-lines-select-dialog',
    templateUrl: './pickup-lines-select-dialog.component.html',
    styleUrls: ['./pickup-lines-select-dialog.component.scss'],
    standalone: false
})
export class PickupLinesSelectDialogComponent implements OnInit {
    result = new Subject<{ success: boolean, pickupLines: PurchaseOrderPickUpLine[] }>();
    pickupLines: PurchaseOrderPickUpLine[];

    async ngOnInit() {
    }

    async save() {
        this.result.next({ success: true, pickupLines: this.pickupLines });
    }

    remove = (pickUpLine: PurchaseOrderPickUpLine) => {
        this.pickupLines = this.pickupLines.filter((line) => line.id !== pickUpLine.id);
    };
}
